<template>
  <div
    class="relative min-h-screen flex items-center justify-center font-poppins px-6 pt-[70px] pb-[61px] md:px-4 lg:pt-0 lg:pb-0"
  >
    <div
      class="absolute inset-0 w-full h-full object-cover -z-10 bg-[#16191D]"
    ></div>

    <img
      src="/create-account-background.svg"
      alt=""
      class="absolute inset-0 w-full h-full object-cover object-center -z-10 hidden lg:block"
      loading="eager"
    />

    <img
      src="/create-account-background-mobile.svg"
      alt=""
      class="absolute inset-0 w-full h-full object-cover object-center -z-10 block lg:hidden"
      loading="eager"
    />

    <div
      class="relative z-10 flex flex-col gap-y-[41px] gap-x-4 justify-center items-center w-full h-full lg:flex-row lg:max-w-[1094px] xl:max-w-[1190px] lg:h-[708px] lg:justify-between lg:items-start"
    >
      <slot />
    </div>
  </div>
</template>
